var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    shapeRendering: "crispEdges",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#D677A2",
    height: 1,
    width: 1,
    x: 2,
    y: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D36DA9",
    height: 1,
    width: 1,
    x: 3,
    y: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D065AF",
    height: 1,
    width: 1,
    x: 4,
    y: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CD5CB5",
    height: 1,
    width: 1,
    x: 5,
    y: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CA52BC",
    height: 1,
    width: 1,
    x: 6,
    y: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C74AC3",
    height: 1,
    width: 1,
    x: 7,
    y: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C441CA",
    height: 1,
    width: 1,
    x: 8,
    y: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C138D0",
    height: 1,
    width: 1,
    x: 9,
    y: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C138D0",
    height: 1,
    width: 1,
    x: 10,
    y: 0
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C138D0",
    height: 1,
    width: 1,
    x: 11,
    y: 0
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C138D0",
    height: 1,
    width: 1,
    x: 12,
    y: 0
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C138D0",
    height: 1,
    width: 1,
    x: 13,
    y: 0
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DC8895",
    height: 1,
    width: 1,
    x: 1,
    y: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 2,
    y: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 3,
    y: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 4,
    y: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 5,
    y: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 6,
    y: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 7,
    y: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD28B8",
    height: 1,
    width: 1,
    x: 8,
    y: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B91DC0",
    height: 1,
    width: 1,
    x: 9,
    y: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 10,
    y: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 11,
    y: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 12,
    y: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 13,
    y: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 14,
    y: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E29A87",
    height: 1,
    width: 1,
    x: 0,
    y: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 1,
    y: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 2,
    y: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 3,
    y: 2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 4,
    y: 2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 5,
    y: 2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 6,
    y: 2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 7,
    y: 2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 8,
    y: 2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 9,
    y: 2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 10,
    y: 2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 11,
    y: 2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 12,
    y: 2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 13,
    y: 2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 14,
    y: 2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9910A8",
    height: 1,
    width: 1,
    x: 15,
    y: 2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E5A381",
    height: 1,
    width: 1,
    x: 0,
    y: 3
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 1,
    y: 3
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 2,
    y: 3
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 3,
    y: 3
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 4,
    y: 3
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 5,
    y: 3
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 6,
    y: 3
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 7,
    y: 3
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 8,
    y: 3
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 9,
    y: 3
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD28B8",
    height: 1,
    width: 1,
    x: 10,
    y: 3
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B91DC0",
    height: 1,
    width: 1,
    x: 11,
    y: 3
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 12,
    y: 3
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 13,
    y: 3
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 14,
    y: 3
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9910A8",
    height: 1,
    width: 1,
    x: 15,
    y: 3
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8AB7B",
    height: 1,
    width: 1,
    x: 0,
    y: 4
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 1,
    y: 4
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 4
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 3,
    y: 4
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 4,
    y: 4
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 5,
    y: 4
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 6,
    y: 4
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 7,
    y: 4
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 8,
    y: 4
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 9,
    y: 4
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 10,
    y: 4
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD28B8",
    height: 1,
    width: 1,
    x: 11,
    y: 4
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B91DC0",
    height: 1,
    width: 1,
    x: 12,
    y: 4
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 4
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 14,
    y: 4
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9910A8",
    height: 1,
    width: 1,
    x: 15,
    y: 4
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EBB574",
    height: 1,
    width: 1,
    x: 0,
    y: 5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 1,
    y: 5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 3,
    y: 5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 4,
    y: 5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 5,
    y: 5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 6,
    y: 5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 7,
    y: 5
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 8,
    y: 5
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 9,
    y: 5
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 10,
    y: 5
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 11,
    y: 5
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD28B8",
    height: 1,
    width: 1,
    x: 12,
    y: 5
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 5
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B613C8",
    height: 1,
    width: 1,
    x: 14,
    y: 5
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9910A8",
    height: 1,
    width: 1,
    x: 15,
    y: 5
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBE6D",
    height: 1,
    width: 1,
    x: 0,
    y: 6
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 1,
    y: 6
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 6
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 3,
    y: 6
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 4,
    y: 6
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 5,
    y: 6
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 6,
    y: 6
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 7,
    y: 6
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 8,
    y: 6
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 9,
    y: 6
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 10,
    y: 6
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 11,
    y: 6
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 12,
    y: 6
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 6
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B91DC0",
    height: 1,
    width: 1,
    x: 14,
    y: 6
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9910A8",
    height: 1,
    width: 1,
    x: 15,
    y: 6
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F1C667",
    height: 1,
    width: 1,
    x: 0,
    y: 7
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 1,
    y: 7
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 7
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 3,
    y: 7
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 4,
    y: 7
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 5,
    y: 7
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 6,
    y: 7
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 7,
    y: 7
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 8,
    y: 7
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 9,
    y: 7
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 10,
    y: 7
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 11,
    y: 7
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 12,
    y: 7
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 7
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD28B8",
    height: 1,
    width: 1,
    x: 14,
    y: 7
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9C19A2",
    height: 1,
    width: 1,
    x: 15,
    y: 7
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F4D060",
    height: 1,
    width: 1,
    x: 0,
    y: 8
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBC4A",
    height: 1,
    width: 1,
    x: 1,
    y: 8
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 8
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 3,
    y: 8
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 4,
    y: 8
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 5,
    y: 8
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 6,
    y: 8
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 7,
    y: 8
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 8,
    y: 8
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 9,
    y: 8
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 10,
    y: 8
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 11,
    y: 8
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 12,
    y: 8
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 8
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C032B0",
    height: 1,
    width: 1,
    x: 14,
    y: 8
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9F229B",
    height: 1,
    width: 1,
    x: 15,
    y: 8
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F8D95A",
    height: 1,
    width: 1,
    x: 0,
    y: 9
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F3C742",
    height: 1,
    width: 1,
    x: 1,
    y: 9
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 9
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 3,
    y: 9
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 4,
    y: 9
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 5,
    y: 9
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 6,
    y: 9
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 7,
    y: 9
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 8,
    y: 9
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 9,
    y: 9
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 10,
    y: 9
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 11,
    y: 9
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 12,
    y: 9
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 9
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C43DA8",
    height: 1,
    width: 1,
    x: 14,
    y: 9
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    fill: "#A22A94",
    height: 1,
    width: 1,
    x: 15,
    y: 9
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F8D95A",
    height: 1,
    width: 1,
    x: 0,
    y: 10
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23A",
    height: 1,
    width: 1,
    x: 1,
    y: 10
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 10
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBC4A",
    height: 1,
    width: 1,
    x: 3,
    y: 10
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 4,
    y: 10
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 5,
    y: 10
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 6,
    y: 10
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 7,
    y: 10
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 8,
    y: 10
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 9,
    y: 10
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 10,
    y: 10
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 11,
    y: 10
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 12,
    y: 10
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 10
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C848A0",
    height: 1,
    width: 1,
    x: 14,
    y: 10
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    fill: "#A5348D",
    height: 1,
    width: 1,
    x: 15,
    y: 10
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F8D95A",
    height: 1,
    width: 1,
    x: 0,
    y: 11
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 1,
    y: 11
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 2,
    y: 11
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F3C742",
    height: 1,
    width: 1,
    x: 3,
    y: 11
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBC4A",
    height: 1,
    width: 1,
    x: 4,
    y: 11
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 5,
    y: 11
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 6,
    y: 11
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 7,
    y: 11
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 8,
    y: 11
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 9,
    y: 11
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 10,
    y: 11
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 11,
    y: 11
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 12,
    y: 11
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 13,
    y: 11
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CB5299",
    height: 1,
    width: 1,
    x: 14,
    y: 11
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    fill: "#A83D87",
    height: 1,
    width: 1,
    x: 15,
    y: 11
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F8D95A",
    height: 1,
    width: 1,
    x: 0,
    y: 12
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 1,
    y: 12
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 2,
    y: 12
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 3,
    y: 12
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F3C742",
    height: 1,
    width: 1,
    x: 4,
    y: 12
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBC4A",
    height: 1,
    width: 1,
    x: 5,
    y: 12
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 6,
    y: 12
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 7,
    y: 12
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 8,
    y: 12
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 9,
    y: 12
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 10,
    y: 12
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 11,
    y: 12
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 12,
    y: 12
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 13,
    y: 12
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CF5D91",
    height: 1,
    width: 1,
    x: 14,
    y: 12
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    fill: "#AB4581",
    height: 1,
    width: 1,
    x: 15,
    y: 12
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F8D95A",
    height: 1,
    width: 1,
    x: 0,
    y: 13
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 1,
    y: 13
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 2,
    y: 13
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 3,
    y: 13
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 4,
    y: 13
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 5,
    y: 13
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 6,
    y: 13
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 7,
    y: 13
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 8,
    y: 13
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 9,
    y: 13
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 10,
    y: 13
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 1,
    width: 1,
    x: 11,
    y: 13
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 12,
    y: 13
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D67281",
    height: 1,
    width: 1,
    x: 13,
    y: 13
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D26789",
    height: 1,
    width: 1,
    x: 14,
    y: 13
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    fill: "#AE4F7A",
    height: 1,
    width: 1,
    x: 15,
    y: 13
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 1,
    y: 14
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 2,
    y: 14
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 3,
    y: 14
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23B",
    height: 1,
    width: 1,
    x: 4,
    y: 14
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D23A",
    height: 1,
    width: 1,
    x: 5,
    y: 14
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F3C742",
    height: 1,
    width: 1,
    x: 6,
    y: 14
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFBC4A",
    height: 1,
    width: 1,
    x: 7,
    y: 14
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB252",
    height: 1,
    width: 1,
    x: 8,
    y: 14
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8A75A",
    height: 1,
    width: 1,
    x: 9,
    y: 14
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E49C62",
    height: 1,
    width: 1,
    x: 10,
    y: 14
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    fill: "#E19269",
    height: 1,
    width: 1,
    x: 11,
    y: 14
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DD8771",
    height: 1,
    width: 1,
    x: 12,
    y: 14
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA7D79",
    height: 1,
    width: 1,
    x: 13,
    y: 14
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    fill: "#B4606D",
    height: 1,
    width: 1,
    x: 14,
    y: 14
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D0B132",
    height: 1,
    width: 1,
    x: 2,
    y: 15
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D0B132",
    height: 1,
    width: 1,
    x: 3,
    y: 15
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D0B132",
    height: 1,
    width: 1,
    x: 4,
    y: 15
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D0B132",
    height: 1,
    width: 1,
    x: 5,
    y: 15
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D0B132",
    height: 1,
    width: 1,
    x: 6,
    y: 15
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    fill: "#CCA838",
    height: 1,
    width: 1,
    x: 7,
    y: 15
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C99E3F",
    height: 1,
    width: 1,
    x: 8,
    y: 15
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C79645",
    height: 1,
    width: 1,
    x: 9,
    y: 15
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C38D4C",
    height: 1,
    width: 1,
    x: 10,
    y: 15
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    fill: "#C08353",
    height: 1,
    width: 1,
    x: 11,
    y: 15
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BD7B59",
    height: 1,
    width: 1,
    x: 12,
    y: 15
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    fill: "#BA725F",
    height: 1,
    width: 1,
    x: 13,
    y: 15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/InstagramLogo.954544b95710a906bf02e5f9dc16f8a6.svg";
export { ForwardRef as ReactComponent };